import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { stats } from '../data/content';

const Stats = () => {
  return (
    <section className="section stats-section text-center">
      <Container>
        <Row>
          {stats.map((stat, index) => (
            <Col md={3} className={index < 3 ? "mb-4 mb-md-0" : ""} key={stat.label}>
              <div className="stat-item">
                <h2 className="stat-number">{stat.value}</h2>
                <p className="stat-title">{stat.label}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Stats;
